@if (loading) {
  <div class="text-center py-4">
    <div class="spinner-border text-primary spinner-border-sm me-2" role="status"></div>
    <span class="text-muted fs-7">Loading snapshot data...</span>
  </div>
}

@if (!loading) {
  <div class="d-flex flex-wrap snapshot-widget">
    <!-- Available Capacity / Vacant Locations -->
    @if ($safeNavigationMigration(data?.availableCapacityValue) !== undefined && !isAllSites) {
      <div class="gauge-container warehouse-gauge-container">
        <a>
          <div class="d-flex justify-content-center align-items-center pt-2">
            <app-warehouseload [percentage]="$safeNavigationMigration(data?.availableCapacityPercentage)"></app-warehouseload>
          </div>
          <div class="gauge-text mt-2">{{ data?.availableCapacityTitle || 'Site1 Vacant Locations' }}</div>
        </a>
      </div>
    }
    <!-- Available Training -->
    @if ($safeNavigationMigration(data?.availableTrainingCenterText) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.availableTrainingPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ data?.availableTrainingCenterText }}</div>
          </div>
          <div class="gauge-text">Available Training</div>
        </a>
      </div>
    }
    <!-- Subscription Contract -->
    @if (subscriptionText !== 'N/A' || $safeNavigationMigration(data?.subscriptionPercentage) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.subscriptionPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ subscriptionText }}</div>
          </div>
          @if (data?.subscriptionTotal) {
            <div class="total-items">{{ data?.subscriptionTotal }}</div>
          }
          <div class="gauge-text">Subscription Contract</div>
        </a>
      </div>
    }
    <!-- Support Contract -->
    @if (supportText !== 'N/A' || $safeNavigationMigration(data?.supportPercentage) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.supportPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ supportText }}</div>
          </div>
          @if (data?.supportTotal) {
            <div class="total-items">{{ data?.supportTotal }}</div>
          }
          <div class="gauge-text">Support Contract</div>
        </a>
      </div>
    }
    <!-- Storage Space -->
    @if ($safeNavigationMigration(data?.storageSpaceCenterText) !== undefined || $safeNavigationMigration(data?.storageSpaceValue) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.storageSpacePercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ data?.storageSpaceCenterText || data?.storageSpaceValue }}</div>
          </div>
          @if (data?.storageSpaceTotal) {
            <div class="total-items">{{ data?.storageSpaceTotal }}</div>
          }
          <div class="gauge-text">Storage Space</div>
        </a>
      </div>
    }
    <!-- Customer Records -->
    @if ($safeNavigationMigration(data?.customerRecordsCenterText) !== undefined || $safeNavigationMigration(data?.customerRecordsValue) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.customerRecordsPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ data?.customerRecordsCenterText || data?.customerRecordsValue }}</div>
          </div>
          <!-- <div class="total-items" *ngIf="data?.customerRecordsTotal">{{ data?.customerRecordsTotal }}</div> -->
          <div class="gauge-text">Customer Records</div>
        </a>
      </div>
    }
    <!-- Connection Speed -->
    @if ($safeNavigationMigration(data?.connectionSpeedValue) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.connectionSpeedPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ data?.connectionSpeedValue }}ms</div>
          </div>
          @if (data?.connectionSpeedTotal) {
            <div class="total-items">{{ data?.connectionSpeedTotal }}</div>
          }
          <div class="gauge-text">Connection Speed</div>
        </a>
      </div>
    }
    <!-- Logged In Users -->
    @if ($safeNavigationMigration(data?.loggedInUsersCenterText) !== undefined) {
      <div class="gauge-container">
        <a>
      <kendo-arcgauge class="kendo-arcgauge" [value]="$safeNavigationMigration(data?.loggedInUsersPercentage)" [scale]="{
          min: 0, max: 100,
          startAngle: -135, endAngle: 135,
          labels: { visible: false },
          rangeSize: 10, rangeDistance: 10
        }">
          </kendo-arcgauge>
          <div class="gauge-center">
            <div class="gauge-value-1">{{ data?.loggedInUsersCenterText }}</div>
          </div>
          <div class="gauge-text">Logged In Users</div>
        </a>
      </div>
    }
  </div>
}
